import { useQuery } from "@apollo/client";
import { FETCH_PRODUCTS } from "@shop/graphql/queries/fetchProducts";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setProducts } from "@store/slices/shop";
import { useShopSlice } from "@store/slices/shop";

export const useProducts = () => {
    const dispatch = useDispatch();
    const { products } = useShopSlice();
    const { data, loading, error } = useQuery(FETCH_PRODUCTS);

    useEffect(() => {
        if (data?.products) {
            dispatch(setProducts(data.products));
        }
    }, [data, dispatch]);

    return { products, loading, error };
};
